import React, { useState, useEffect, useContext } from 'react';
import axios from '../../../axios/index';
import usePriceSeprator from "../../../hooks/usePriceSeparator";

// Context
import { UserContext } from '../../Context/UserContextProvider';

//Styles 
// import myStyles from "../../Dashboard/DashboardAddNewFile/AddNewFileMainPage/AddNewFileMainPage.module.css";
import Dstyles from "../../Dashboard/DashboardAddNewFile/AddNewFileMainPage/AddNewFileMainPage.module.css"
import 'react-toastify/dist/ReactToastify.css';
import styles from "./UserAddNewFile.module.css"

// Re Useable Components
import HomeNavbar from '../../Home/HomeNavbar/HomeNavbar';
import Footer from '../../Home/Footer/Footer';
import UserSideDashboard from '../UserSideDashboard/UserSideDashboard';
import CategoryCards from './../../Dashboard/DashboardAddNewFile/SelectCategory/CategoryCards';
import SubCategoryCards from './../../Dashboard/DashboardAddNewFile/SelectCategory/SubCategoryCards';
import AddNewFile from './../../Dashboard/DashboardReuseAbleComponents/AddNewFile';
// import AddSubCategory from './../../Dashboard/DashboardAddNewFile/AddSubCategory/AddSubCategory';

//Images
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg"

export default function UserAddNewFile() {
    const { userToken } = useContext(UserContext)
    const [categories, setCategories] = useState()
    const [subCategories, setSubCategories] = useState()
    const [showPage, setShowPage] = useState({
        pageNumber: 1,
        categoriID: "",
        categoriTitle: "",
        subCategoryID: "",
        selectedSub: "",
        subIsSelected: false
    })
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const dataHandler = async () => {
            const apiData = await axios.get(
                "Category/GetParentCategories",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            if (showPage.subIsSelected) {
                const getSubCategory = await axios.get(
                    `Category/getChild/${showPage.categoriID}`,
                    {
                        headers: { authorization: "Bearer " + userToken },
                    }
                );
                setSubCategories(getSubCategory.data.data)
            }
            setCategories(apiData.data.data)
            setIsLoading(false)
        }
        dataHandler()
    }, [userToken, showPage.subIsSelected, showPage.categoriID])

    return (
        <>

            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir='rtl'>
                        <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
                            <HomeNavbar />
                            <div className="container py-3 px-0 mt-4">
                                <div className='w-100 d-flex justify-content-md-between justify-content-center align-items-start'>
                                    <UserSideDashboard myAds />

                                    <div className={`d-flex flex-column align-items-center justify-content-start p-3 ${styles.main_container}`}>

                                        {showPage.pageNumber === 1 ?
                                            <>
                                                <div className="container-fluid">
                                                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center" dir="rtl">
                                                        <div className='w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2'>
                                                            <div className='d-flex align-items-center justify-content-center'>
                                                                <img className='ms-2' src={arrowIcon} alt="icon" />
                                                                <div className={Dstyles.text1}>
                                                                    ایجاد فایل جدید
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='w-100 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap mt-4 mb-2'>
                                                            <div className={styles.header_text2}>
                                                                لطفا دسته‌بندی مورد نظر را انتخاب کنید.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <CategoryCards setIsLoading={setIsLoading} categories={categories} setCategories={setCategories} isConsultant={false} setShowPage={setShowPage} userAdd={true} />

                                            </>
                                            :
                                            showPage.pageNumber === 2 ?
                                                <>
                                                    <div className='w-100 d-flex flex-column align-items-start justify-content-start flex-wrap my-4'>
                                                        <div className={`mt-md-0 mt-2 mb-4 ${styles.title}`}>
                                                            ایجاد اگهی جدید
                                                        </div>
                                                        <div className={styles.title_sm}>
                                                            <img className='ms-2 pointer' src={arrowIcon} alt="icon" onClick={backHandler} />
                                                            نوع ملک مورد نظر را انتخاب کنید
                                                        </div>
                                                    </div>

                                                    <SubCategoryCards subCategories={subCategories} setShowPage={setShowPage} userAdd={true} />
                                                </>
                                                :
                                                showPage.pageNumber === 4 &&
                                                <>
                                                    <AddNewFile usePriceSeprator={usePriceSeprator} title={showPage.selectedSub} categoryID={showPage.categoriID} subCategoryID={showPage.subCategoryID} setState={setShowPage} categoryTitle={showPage.categoriTitle} setIsLoading={setIsLoading} userAdd={true} />
                                                </>
                                        }

                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                )}
        </>
    )

    function backHandler() {
        setShowPage((prev) => {
            return { ...prev, categoriID: "", pageNumber: 1, subIsSelected: false };
        })
    }
}
